import { Sprint } from 'api/sprint-planning/types';
import {
  PhaseAsParent,
  TaskAsParent,
} from 'components/organisms/templates/projects/commons/rearrange/types';
import type { Task } from 'data/tasks';
import { PhaseEntity, PhaseEntityType } from './generics';

export function isPhase(
  rearrangeEntity: PhaseAsParent | TaskAsParent,
): rearrangeEntity is PhaseAsParent {
  return typeof (rearrangeEntity as PhaseAsParent).projectPhase !== 'undefined';
}

export function isTask(entity: PhaseEntity): entity is Task {
  return typeof (entity as Task).taskId === 'number';
}

export function isTaskId(fullyQualifiedId: string) {
  return fullyQualifiedId.startsWith(PhaseEntityType.Task);
}

export function isSprint(entity: PhaseEntity): entity is Sprint {
  return typeof (entity as Sprint).sprintId === 'number';
}

export function getId(item: PhaseEntity, withEntityName: true): string;
export function getId(item: PhaseEntity, withEntityName?: false): number;
export function getId(item: PhaseEntity, withEntityName = false) {
  if (isTask(item)) {
    return withEntityName
      ? `${PhaseEntityType.Task}_${item.taskId}`
      : item.taskId;
  }
  if (isSprint(item)) {
    return withEntityName
      ? `${PhaseEntityType.Sprint}_${item.sprintId}`
      : item.sprintId;
  }

  return undefined;
}

export function extractId(entityId: string) {
  const lastUnderscoreIndex = entityId.lastIndexOf('_');
  const idString = entityId.substring(lastUnderscoreIndex + 1);

  return parseInt(idString, 10);
}

export function extractParts(entityId: string) {
  const parts = entityId.split('_');

  const entityType = parts.slice(0, -1).join('_') as PhaseEntityType;
  const id = parseInt(parts[parts.length - 1], 10);

  return { entityType, id };
}

/**
 * Format of entityId is {entityType}_{id}
 * Example: TASK_123, SPRINT_456
 */
export function converToEntityId(id: number, entityType: PhaseEntityType) {
  return `${entityType}_${id}`;
}

/**
 * This function is used to convert from {type}-{id} format to {type}_{id}.
 * Many table (ag grid) and gannt configs uses {type}-{id} format.
 */
export function convertKeyToEntityId(key: string) {
  const lastDashIndex = key.lastIndexOf('-');
  const entityId = `${key.substring(0, lastDashIndex)}_${key.substring(
    lastDashIndex + 1,
  )}`;

  return entityId;
}
